import LoginForm from '../components/forms/auth/csi-login-form';

const CSILogin = () => (<LoginForm/>);
  
export default CSILogin;
  